import { injectGlobal } from "styled-components";

function fontFace(name, src, fontWeight = "normal", fontStyle = "normal") {
  return `
        @font-face{
            font-family: "${name}";
            src: url(${require("./assets/fonts/" + src + ".eot")});
            src: url(${require("./assets/fonts/" +
              src +
              ".eot")}?#iefix) format("embedded-opentype"),
                 url(${require("./assets/fonts/" +
                   src +
                   ".woff")}) format("woff"),
                 url(${require("./assets/fonts/" +
                   src +
                   ".ttf")}) format("truetype"),
                 url(${require("./assets/fonts/" +
                   src +
                   ".svg")}#${name}) format("svg");

            font-style: ${fontStyle};
            font-weight: ${fontWeight};
        }
    `;
}

injectGlobal`
  ${fontFace("GT-Walsheim", "GT-Walsheim-Bold", "bold")}

  ${fontFace("GT-Walsheim", "GT-Walsheim-Light")}


    body {
      font-family: 'GT-Walsheim';
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-size: 1.3em;
    }

    a {
      color: black;
    }


`;



// WEBPACK FOOTER //
// ./src/globalStyles.js